import React, { useEffect } from 'react';
import { List, Datagrid, FunctionField } from 'react-admin';

function PublicidadHistoriaList(props: any) {
  useEffect(() => {
    document.title = 'Publicidad Historia - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <FunctionField
          label="Descripción"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || '';
            return <span>{text.substring(0, 100)}...</span>;
          }}
        />
        <FunctionField
          label="Archivo"
          render={(record: any) => {
            const name = record.archivo?.name || record.archivo?.attributes?.name || record.archivo?.data?.attributes?.name || '';
            return <span>{name || (record.archivo ? 'Sí' : 'No')}</span>;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default PublicidadHistoriaList;
